import { createSelector } from 'reselect';

const selectEndpoints = (state: any) => state.endpoints;


export const selectEndpointsCurrentItem = createSelector([selectEndpoints], (endpoints) => endpoints.current);

export const selectEndpointsListItems = createSelector([selectEndpoints], (endpoints) => endpoints.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectEndpointsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEndpointsQueryItems = createSelector([selectEndpoints], (endpoints) => endpoints.query);

export const selectEndpointsCreatedItem = createSelector([selectEndpoints], (endpoints) => endpoints.create);

export const selectEndpointsUpdatedItem = createSelector([selectEndpoints], (endpoints) => endpoints.update);

export const selectEndpointsReadItem = createSelector([selectEndpoints], (endpoints) => endpoints.read);

export const selectEndpointsDeletedItem = createSelector([selectEndpoints], (endpoints) => endpoints.delete);

export const selectEndpointsSearchedItems = createSelector([selectEndpoints], (endpoints) => endpoints.search);

export const selectEndpointsItemsCount = createSelector([selectEndpoints], (endpoints) => endpoints.count);

export const selectEndpointsItemsFilter = createSelector([selectEndpoints], (endpoints) => endpoints.filter);